import React from "react";

const HelpDialog = ({ open, onClose, helpImage }) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
    >
      {/* Background Overlay (black + blur + transparency) */}
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.6)",
          backdropFilter: "blur(4px)",
        }}
      ></div>

      {/* Dialog Box */}
      <div
        style={{
          position: "relative",
          background: "#fff",
          borderRadius: "12px",
          padding: "16px",
          maxWidth: "400px",
          width: "90%",
          boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
          zIndex: 10000,
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            fontWeight: "bold",
            color: "#333",
            border: "none",
            background: "transparent",
            cursor: "pointer",
          }}
        >
          ✕
        </button>

        {/* Image Content */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={helpImage}
            alt="Help"
            style={{
              maxHeight: "70vh",
              width: "100%",
              borderRadius: "8px",
              display: "block",
              margin: "23px auto",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default HelpDialog;
